import angular from 'angular';
import SiteOperationalStatusWidgetComponent from './site-operational-status-widget-component';
import SiteOperationalStatusRetailerListModule from './components/site-operational-status-retailer-list/site-operational-status-retailer-list-module';
import SiteOperationalStatusIndicatorModule from './components/site-operational-status-indicator/site-operational-status-indicator-module';
import SiteOperationalStatusDeviceListModule from './components/site-operational-status-device-list/site-operational-status-device-list-module';

export default angular
  .module('site-operational-status-widget', [
    SiteOperationalStatusRetailerListModule.name,
    SiteOperationalStatusIndicatorModule.name,
    SiteOperationalStatusDeviceListModule.name,
  ])
  .component('siteOperationalStatusWidget', new SiteOperationalStatusWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/site-operational-status/site-operational-status-widget-module.js